// Bloqueador de navegación global que se ejecuta ANTES de React
// Este script se ejecuta inmediatamente cuando se carga la página

(function() {
  'use strict'
  
  // Inicializar bloqueador global de navegación (sin logs)
  
  // Función para verificar si el modal está abierto
  const isModalOpen = () => {
    try {
      return sessionStorage.getItem('pdfEditor_showShareModal') === 'true'
    } catch (e) {
      return false
    }
  }
  
  // Bloquear TODAS las formas de navegación
  const blockAllNavigation = () => {
    if (!isModalOpen()) {
      return
    }
    
    // No hacer logs - solo bloquear silenciosamente
    
    // Bloquear window.location.reload() - solo si no está ya bloqueado
    if (!window.__modalBlocker_originalReload) {
      try {
        const descriptor = Object.getOwnPropertyDescriptor(window.location, 'reload')
        if (descriptor && descriptor.configurable) {
          window.__modalBlocker_originalReload = window.location.reload.bind(window.location)
          Object.defineProperty(window.location, 'reload', {
            value: function() {
              if (isModalOpen()) {
                return
              }
              return window.__modalBlocker_originalReload()
            },
            writable: false,
            configurable: true
          })
        }
      } catch (e) {
        // Silenciar error si ya está bloqueado
      }
    }
    
    // Bloquear window.location.replace() - solo si no está ya bloqueado
    if (!window.__modalBlocker_originalReplace) {
      try {
        const descriptor = Object.getOwnPropertyDescriptor(window.location, 'replace')
        if (descriptor && descriptor.configurable) {
          window.__modalBlocker_originalReplace = window.location.replace.bind(window.location)
          Object.defineProperty(window.location, 'replace', {
            value: function(url) {
              if (isModalOpen()) {
                return
              }
              return window.__modalBlocker_originalReplace(url)
            },
            writable: false,
            configurable: true
          })
        }
      } catch (e) {
        // Silenciar error si ya está bloqueado
      }
    }
    
    // Bloquear window.location.assign() - solo si no está ya bloqueado
    if (!window.__modalBlocker_originalAssign) {
      try {
        const descriptor = Object.getOwnPropertyDescriptor(window.location, 'assign')
        if (descriptor && descriptor.configurable) {
          window.__modalBlocker_originalAssign = window.location.assign.bind(window.location)
          Object.defineProperty(window.location, 'assign', {
            value: function(url) {
              if (isModalOpen()) {
                return
              }
              return window.__modalBlocker_originalAssign(url)
            },
            writable: false,
            configurable: true
          })
        }
      } catch (e) {
        // Silenciar error si ya está bloqueado
      }
    }
    
    // Bloquear window.location.href
    if (!window.__modalBlocker_originalHrefSetter) {
      try {
        const descriptor = Object.getOwnPropertyDescriptor(window.location, 'href')
        if (descriptor && descriptor.set) {
          window.__modalBlocker_originalHrefSetter = descriptor.set
          // Solo intentar redefinir si es configurable
          if (descriptor.configurable) {
            Object.defineProperty(window.location, 'href', {
              set: function(value) {
                if (isModalOpen()) {
                  console.log('[ModalNavigationBlocker] 🚫 BLOQUEANDO window.location.href =', value)
                  return
                }
                return window.__modalBlocker_originalHrefSetter.call(window.location, value)
              },
              get: descriptor.get || function() {
                return window.location.href
              },
              configurable: true
            })
          }
        }
      } catch (e) {
        // Si no se puede redefinir, simplemente no bloquear href
        console.warn('[ModalNavigationBlocker] No se pudo bloquear href (puede ser de solo lectura):', e.message)
      }
    }
    
    // Bloquear history.pushState
    if (!window.__modalBlocker_originalPushState) {
      window.__modalBlocker_originalPushState = window.history.pushState
      window.history.pushState = function(...args) {
        if (isModalOpen()) {
          console.log('[ModalNavigationBlocker] 🚫 BLOQUEANDO history.pushState')
          return
        }
        return window.__modalBlocker_originalPushState.apply(window.history, args)
      }
    }
    
    // Bloquear history.replaceState
    if (!window.__modalBlocker_originalReplaceState) {
      window.__modalBlocker_originalReplaceState = window.history.replaceState
      window.history.replaceState = function(...args) {
        if (isModalOpen()) {
          console.log('[ModalNavigationBlocker] 🚫 BLOQUEANDO history.replaceState')
          return
        }
        return window.__modalBlocker_originalReplaceState.apply(window.history, args)
      }
    }
    
    // Bloquear beforeunload
    if (!window.__modalBlocker_beforeUnloadHandler) {
      window.__modalBlocker_beforeUnloadHandler = (e) => {
        if (isModalOpen()) {
          console.log('[ModalNavigationBlocker] 🚫 BLOQUEANDO beforeunload')
          e.preventDefault()
          e.returnValue = ''
          return ''
        }
      }
      window.addEventListener('beforeunload', window.__modalBlocker_beforeUnloadHandler, { capture: true })
    }
    
    // Bloquear popstate
    if (!window.__modalBlocker_popstateHandler) {
      window.__modalBlocker_popstateHandler = (e) => {
        if (isModalOpen()) {
          console.log('[ModalNavigationBlocker] 🚫 BLOQUEANDO popstate')
          e.preventDefault()
          if (window.history.pushState) {
            window.history.pushState(null, '', window.location.href)
          }
        }
      }
      window.addEventListener('popstate', window.__modalBlocker_popstateHandler, { capture: true })
    }
  }
  
  // Bloquear INMEDIATAMENTE si el modal está abierto
  if (isModalOpen()) {
    blockAllNavigation()
  }
  
  // Monitorear sessionStorage constantemente - INTERCEPTAR setItem
  const originalSetItem = Storage.prototype.setItem
  Storage.prototype.setItem = function(key, value) {
    const result = originalSetItem.call(this, key, value)
    if (key === 'pdfEditor_showShareModal' && value === 'true') {
      // Bloquear INMEDIATAMENTE, sin setTimeout
      blockAllNavigation()
      // También verificar después de un microsegundo para asegurar
      setTimeout(() => blockAllNavigation(), 0)
    }
    return result
  }
  
  // Verificar constantemente cada 1000ms (1 segundo) para mejor rendimiento
  setInterval(() => {
    if (isModalOpen()) {
      blockAllNavigation()
    }
  }, 1000)
  
  // También interceptar cuando se lee sessionStorage para verificar
  const originalGetItem = Storage.prototype.getItem
  Storage.prototype.getItem = function(key) {
    const result = originalGetItem.call(this, key)
    if (key === 'pdfEditor_showShareModal' && result === 'true') {
      // Si alguien lee el sessionStorage y el modal está abierto, asegurar bloqueo
      setTimeout(() => blockAllNavigation(), 0)
    }
    return result
  }
  
  // Bloqueador global activado
})()

